import { useEffect } from "react";
// import { useNavigate, redirect, useLocation } from 'react-router-dom';
import { ThemeProvider } from "./component/ThemeContext";
import i18n from './i18n';
import SessionUtil from "./util/SessionUtil";
import AppWrapper from "./routes/Routes";

function App() {
  const lang = SessionUtil.getLang();
  // const navigate = useNavigate();
  // const location = useLocation();
  const isLoggedIn = SessionUtil.isLoggedIn();
  const userType = SessionUtil.getTypeUser();  
  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  useEffect(() => {
    if (lang === 'ar') {
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
    }
  }, [lang])

  useEffect(() => {
  //   if (isLoggedIn) {
  //     const targetRoute = userType === '1' ? '/operation' :
  //         '/driver-list';
  //     if (location.pathname === '/') {
  //       navigate(targetRoute, { replace: true });
  //     }
  //     redirect(targetRoute, { replace: true });
  //   } else {
  //     if (location.pathname !== '/') {
  //       navigate('/', { replace: true });
  //     }
  //     redirect('/');
  //   }
  }, [isLoggedIn, userType,]);
  return (
    <ThemeProvider>
      <AppWrapper />
    </ThemeProvider>
  );
}

export default App;